import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";

@Component({
  selector: "app-autocomplete-email-search",
  templateUrl: "./autocomplete-email-search.component.html",
  styleUrl: "./autocomplete-email-search.component.scss",
})
export class AutocompleteEmailSearchComponent implements OnInit, OnChanges {
  selectedItem: any = null;
  @Input() ctrlName: any;
  @Input() suggestions: any[] = [];
  @Input() isMultipleSelected: boolean = false;
  @Input() isCompleteOnFocus: boolean = false;
  @Input() isDisabled: boolean = false;
  @Output() searchChange = new EventEmitter<any>();
  @Output() emailChange = new EventEmitter<any>();

  ngOnInit(): void {
    if (!this.isMultipleSelected && (this.ctrlName || this.ctrlName === "")) {
      this.selectedItem = this.ctrlName || null;
    }

    if (this.isMultipleSelected && this.ctrlName) {
      this.selectedItem = this.ctrlName;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes &&
      !this.isMultipleSelected &&
      (changes?.ctrlName?.currentValue ||
        changes?.ctrlName?.currentValue === "")
    ) {
      this.selectedItem = changes?.ctrlName?.currentValue || null;
    }

    if (this.isMultipleSelected && this.ctrlName) {
      this.selectedItem = this.ctrlName;
    }
  }

  search(event: any) {
    const query = event.query;
    setTimeout(() => {
      this.searchChange.emit(query);
    }, 1500);
  }

  onSelectItem(event: any) {
    this.emailChange.emit(
      this.isMultipleSelected ? this.selectedItem : this.selectedItem?.email,
    );
  }

  onModelChange(value: any) {
    if (this.isMultipleSelected) {
      this.emailChange.emit(value);
      return;
    }

    // If cleared or typed text (no object with email), emit empty string
    if (!value || (typeof value === "string" && value.trim() === "")) {
      this.selectedItem = null;
      this.emailChange.emit("");
      return;
    }

    // If an object with email selected
    if (value?.email) {
      this.selectedItem = value;
      this.emailChange.emit(value.email);
    }
  }
}
